import React, { Fragment, useEffect, useState } from "react";
import { any, func } from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import FormCreatorV2 from "../../common/FormCreatorV2";
import {
  formCreatorConvertToValues,
  useForm,
} from "../../common/FormCreator/helpers";
import HorizontalLine from "../../common/HorizontalLine";
import history from "../../history";
import { postDnataForm } from "../../redux/actions/dnataActions";
import { buildAddress } from "../../helpers/form";

const InformationForm = ({ appData, postDnataFormFunc }) => {
  const onboarding =
    appData.dnataOnboarding && appData.dnataOnboarding.information;

  let initialData = {
    currentAddress: buildAddress(appData.address, true),
  };

  if (onboarding) {
    initialData = {
      ...initialData,
      ...onboarding,
    };
  }

  let initialAddressHistoryData = [
    {
      Address: "",
      "Moved In": "",
      "Moved Out": "",
    },
  ];

  if (onboarding && onboarding.addressHistoryData) {
    const addressHistory = onboarding.addressHistoryData;
    initialAddressHistoryData = Object.keys(addressHistory).map(
      (key) => addressHistory[key]
    );
  }

  const [addressHistoryData, setAddressHistoryData] = useState(
    initialAddressHistoryData
  );

  const isEmpty = (val) => typeof val === "undefined" || val === null;
  const getField = (data) => (fieldName) =>
    !isEmpty(data[fieldName]) ? data[fieldName] : "";

  const getVal = getField(initialData);

  const removeLastAddress = () => {
    const newAddressHistoryData = addressHistoryData.filter(
      (el, i) => i < addressHistoryData.length - 1
    );
    setAddressHistoryData(newAddressHistoryData);
  };

  const setValueAddress = (value, key, i) => {
    const mappedHistoryData = addressHistoryData.map((el, index) => {
      if (i === index) {
        return { ...el, [key]: value };
      }
      return el;
    });

    setAddressHistoryData(mappedHistoryData);
  };

  const initialState = {
    blurbSection7: {
      htmlObj: <HorizontalLine text={"Section 7 - Additional Information"} />,
    },
    Group18: {
      type: "checkbox",
      title: "Do you have any holidays booked?",
      value: getVal("Group18"),
      mandatory: true,
    },
    supplyDates: {
      title: "If yes, please supply dates:",
      value: getVal("supplyDates"),
      mandatory: true,
      dependOn: [{ fieldKey: "Group18" }],
    },
    Group19: {
      title:
        "Due to health or disability reasons do you require any reasonable adjustments to be made so that you can take part in an interview or on an assessment day?",
      value: getVal("Group19"),
      type: "checkbox",
      mandatory: true,
    },
    adjustments: {
      title: "If yes, please specify:",
      value: getVal("adjustments"),
      type: "textarea",
      mandatory: true,
      dependOn: [{ fieldKey: "Group19" }],
    },
    Group20: {
      title: "How did you hear about the vacancy?",
      type: "radio",
      value: getVal("Group20"),
      radioOptions: [
        "Total Jobs",
        "LinkedIn",
        "Facebook",
        "Twitter",
        "Job Fair",
        "Job Centre",
        "Refer a friend",
      ],
    },
    otherHear: {
      title: "Other (please specify)",
      value: getVal("otherHear"),
    },

    box19: {
      htmlObj: (
        <Fragment>
          <HorizontalLine text={"Section 9 - 5 Year Address History"} />
          <p>
            Please state all the address you have lived at in the last 5 years
            including moving in and out dates.
          </p>
          Address History
          <br />
          Current Address
        </Fragment>
      ),
    },
    currentAddress: {
      title: "Address",
      value: getVal("currentAddress"),
      type: "text",
      disabled: true,
    },
    currentAddressMovedIn: {
      title: "Moved In",
      value: getVal("currentAddressMovedIn"),
      type: "date",
      mandatory: true,
      validate: () => true,
    },
    addressHistoryData: {
      type: "addressHistoryV2",
      addressHistoryColumns: [
        {
          title: "Address",
          type: "text",
        },
        {
          title: "Moved In",
          type: "date",
        },
        {
          title: "Moved Out",
          type: "date",
        },
      ],
      initialAddressHistory: initialAddressHistoryData,
      onlyPrevious: true,
    },
    box20: {
      htmlObj: (
        <Fragment>
          <HorizontalLine
            text={"Section 10 - Criminal Records And Convictions"}
          />
          <br />
          <p
            style={{ color: "red", display: "flex", justifyContent: "center" }}
          >
            IMPORTANT - PLEASE READ
          </p>

          <p>
            Your role may involve you carrying out tasks which are classified as
            being a security function. Where this is the case you will be
            required to undergo a Criminal Record Check.
          </p>
          <p>
            The Civil Aviation Authority govern the industry in which dnata
            Catering UK operates and they provide a list of disqualified
            convictions which can be found by visiting their website:
            <br />
            <a
              href="https://caa.co.uk/default.aspx?catid=2780&pageid=15971"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://caa.co.uk/default.aspx?catid=2780&pageid=15971
            </a>
          </p>
          <p>
            Consequently if you were to have one of these convictions listed as
            part of your CRC we would be unable to employ you. To reassure you,
            you should not assume that if you do have conviction it will mean
            that we are unable to employ you. Dnata catering UK will comply
            fully with the Rehabilitation of Offenders Act 1974..
          </p>
          <p>
            Please note that if you have been out of the UK for 6 months or more
            in a particular country within the last 5 years you must also apply
            to that country for a CRC. Please liaise with HR who will support
            you in this process.
          </p>
          <p>
            You must provide details of any offence for which you may go to
            court for or are awaiting a hearing. This includes any offences for
            which you have been arrested and are waiting to hear if you will be
            formally charged.
          </p>
        </Fragment>
      ),
    },
    Group21: {
      title:
        "Do you have any criminal convictions which are not yet 'spent' under the Rehabilitation of Offenders Act 1974?",
      type: "checkbox",
      value: getVal("Group21"),
      mandatory: true,
    },
    conviction: {
      title: "If yes, please give details and dates below:",
      value: getVal("conviction"),
      type: "textarea",
      dependOn: [{ fieldKey: "Group21" }],
      mandatory: true,
    },
    convictionBlurb: {
      htmlObj: (
        <Fragment>
          <p>
            <bold>How Do I Know If My Conviction Is Spent?</bold>
          </p>
          <p>
            For further information on how to determine whether a conviction is
            spent please visit the Unlock website:
            <br />
            <a
              href="https://hub.unlock.org.uk/knowledgebase/spent-now-brief-guide-changes-roa/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://hub.unlock.org.uk/knowledgebase/spent-now-brief-guide-changes-roa/
            </a>
          </p>
        </Fragment>
      ),
    },
  };

  const [fields, setField] = useForm(initialState);

  const handleSubmit = () => {
    const restFields = formCreatorConvertToValues(fields);
    const fieldValuesPayload = { addressHistoryData, ...restFields };
    postDnataFormFunc("information", {
      ...fieldValuesPayload,
    });
    history.push("/profile/edit/dnata-onboarding");
  };

  return (
    <FormCreatorV2
      formTitle={"Additional Information"}
      fields={fields}
      setField={setField}
      handleSubmit={handleSubmit}
      handleCancel={() => history.push("/profile/edit/dnata-onboarding")}
      onboardingBranch={"dnata"}
      addressValidationErrorMessage={[]}
      addressHistoryData={addressHistoryData}
      setAddressHistoryData={setAddressHistoryData}
      addressHistoryRemoveLast={removeLastAddress}
      setAddressHistoryValue={setValueAddress}
    />
  );
};
InformationForm.propTypes = {
  appData: any,
  postDnataFormFunc: func.isRequired,
};
const mapDispatchToProps = {
  postDnataFormFunc: postDnataForm,
};
const mapStateToProps = (state) => ({
  appData: state.core.app,
});
const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(InformationForm);
